module.exports = __webpack_public_path__ + "img/shigeno.9a7594bd.jpg";